import BaseStore from './BaseStore';

export class ScreenStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      fullscreen: '0',
      activeFullScreen: false,
    });
  }

  setFullScreen(value) {
    this.activeFullScreen = value;
  }
}

export default new ScreenStore();
